function changeLinks(listUrl, bDebug){
  var arr = [], l=document.links;
  var lang = document.documentElement.getAttribute("lang");
  for(var i = 0; i < l.length; i++){
    for(u = 0; u < listUrl.length; u++){
      if(l[i].href.indexOf(listUrl[u]) > -1 && l[i].href.indexOf("https://ch.amc.") == -1){
        var mylink = document.querySelectorAll("a[href='" + l[i].href + "']");
        for(let y of mylink){
          replaceLink(lang, y);
          y.setAttribute("target", "_blank");
        }    
        arr.push(l[i].href);
      }
    }
  }
  
  if(bDebug && arr.length > 0){
    alert(arr.length + " links modified");
    console.log(arr);
  }
}


function replaceLink(lang, languageLink){
  if(lang == 'fr'){
    switch(languageLink.href){
        case 'https://www.amc.info/de-ch/amc-erleben/events/':
        languageLink.href = 'https://www.amc.info/fr-ch/lexperience/evenements/';
        break;        
    }
  }else if (lang == 'it'){
    switch(languageLink.href){
        case 'https://www.amc.info/de-ch/amc-erleben/events/':
        languageLink.href = 'https://www.amc.info/it-ch/prova-amc/eventi/';
        break;
    }
  }
}
changeLinks(['https://www.amc.info'],false);